import { ILanguage } from 'translations/types';

import { IndicatorMetadataDto } from 'generated/apiSchemas';

export const getIndicatorName = (
  indicators: IndicatorMetadataDto[],
  id: string,
  language: string,
) => {
  const currentIndicator = indicators.find((indicator) => indicator.id === id);
  if (!currentIndicator) {
    return null;
  }

  switch (language) {
    case ILanguage.enUS:
    case ILanguage.enGB:
      return currentIndicator.nameEn;
    case ILanguage.es:
      return currentIndicator.nameEs;
    case ILanguage.fr:
      return currentIndicator.nameFr;
    default:
      return null;
  }
};
